import { Button, Tooltip } from '@mui/material';

const ActiveDeactivateButton = ({ activationStatus, handleOnClick }) => {
	const isActive = activationStatus === 'Active';
	const label = isActive ? 'Active' : 'Deactive';
	const tooltip = isActive ? 'Deactivate' : 'Activate';

	return (
		<Tooltip title={tooltip}>
			<Button
				type="button"
				sx={{
					height: '36px',
					px: 2,
					fontSize: '14px',
					lineHeight: '20px',
					fontWeight: 500,
					borderRadius: '10px',
					textTransform: 'none',
					boxShadow: 'none',
					transition: 'all 0.2s ease',
					color: isActive ? '#FFFFFF' : '#344054',
					border: isActive ? '1px solid #101828' : '1px solid #D0D5DD',
					backgroundColor: isActive ? '#101828' : '#FFFFFF',
					'&:hover': {
						boxShadow: 'none',
						backgroundColor: isActive ? '#0F172A' : '#F9FAFB',
						borderColor: isActive ? '#101828' : '#98A2B3',
					},
				}}
				onClick={handleOnClick}
			>
				{label}
			</Button>
		</Tooltip>
	);
};

export default ActiveDeactivateButton;
